import VpnKeyIcon from '@material-ui/icons/VpnKey';

import { AppSecretsBlock } from './AppSecretsBlock';
import { AppSecretsDatagrid } from './AppSecretsDatagrid';
import { AppSecretsCreate } from './Create/Create';
import { AppSecretForm } from './Form/Form';
import { AppSecretsList } from './List/List';
import { AppSecretsShow } from './Show/Show';
import { CreateWebhookSecretButton } from './CreateWebhookSecretButton';


export {
	AppSecretsBlock,
	AppSecretsDatagrid,
	AppSecretsCreate,
	AppSecretForm,
	AppSecretsList,
	AppSecretsShow,
	CreateWebhookSecretButton,
};


export const appSecretsResource = {
	list: AppSecretsList,
	create: AppSecretsCreate,
	show: AppSecretsShow,
	icon: VpnKeyIcon,
};
